import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import { PdfOutlineIcon, DocumentsOutlineIcon, PaperClipIcon } from 'assets/icons';
import { ChannelMessageAttachmentType } from 'shared/types/graphql';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface IFileAttachmentProps {
  url: string;
  filename: string;
  setPreviewData: (fileUrl: string, attachmentType: ChannelMessageAttachmentType, fileName: string) => void;
}

const FileAttachment = ({ url, filename, setPreviewData }: IFileAttachmentProps): JSX.Element => {
  const renderTypeIcon = (filename: string): JSX.Element | null => {
    if (!filename) return null;
    if (filename?.includes('pdf')) {
      return (
        <IconContainer>
          <PdfOutlineIcon />
        </IconContainer>
      );
    } else if (filename?.includes('doc')) {
      return (
        <IconContainer>
          <DocumentsOutlineIcon />
        </IconContainer>
      );
    } else {
      return (
        <IconContainer>
          <PaperClipIcon />
        </IconContainer>
      );
    }
  };

  const handlePreviewClick = useCallback(() => {
    if (filename?.includes('pdf')) {
      setPreviewData(url || '', ChannelMessageAttachmentType.File, filename || '');
    } else {
      Object.assign(document.createElement('a'), { target: '_blank', href: url }).click();
    }
  }, [setPreviewData, filename, url]);

  return (
    <FileContainer onClick={(): void => handlePreviewClick()}>
      {renderTypeIcon(filename || '')}
      <AttachmentNameContainer>
        <Text isTruncated noOfLines={2}>
          {filename}
        </Text>
      </AttachmentNameContainer>
    </FileContainer>
  );
};

export default FileAttachment;

const FileContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const AttachmentNameContainer = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
`;

const IconContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  &:hover {
    opacity: 0.7;
  }

  & svg {
    width: auto;
    height: 20px;
  }

  & svg * {
    fill: var(--chakra-colors-text-default);
  }
`;
